import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { normalizeHeroData } from '../../utils/blockUtils';

const HeroBlock = ({ data, isSelected, previewMode }) => {
  const normalized = normalizeHeroData(data);
  const {
    title = 'Welcome to Our Newsletter',
    subtitle = 'Stay updated with our latest news',
    description = 'Stay updated with our latest news',
    backgroundImage = '',
    backgroundColor = '#f8f9fa',
    textColor = '#333333',
    titleColor = '#333333',
    subtitleColor = '#666666',
    descriptionColor = '#666666',
    titleFontSize = 32,
    descriptionFontSize = 18,
    textAlign = 'center',
    padding = '60px 20px',
    buttonText = 'Get Started',
    buttonLink = '#',
    buttonBackgroundColor = '#007bff',
    buttonTextColor = '#ffffff',
    showButton = true,
    marginTop = 0,
    marginBottom = 0,
    fontFamily = 'Arial, sans-serif',
  } = normalized;

  const getResponsivePadding = () => {
    switch (previewMode) {
      case 'mobile':
        return '40px 15px';
      case 'tablet':
        return '50px 20px';
      default:
        return padding;
    }
  };

  const containerStyles = {
    backgroundColor,
    backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'none',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    padding: getResponsivePadding(),
    textAlign,
    color: textColor,
    marginTop: `${marginTop}px`,
    marginBottom: `${marginBottom}px`,
    border: isSelected ? '2px dashed #007bff' : 'none',
    borderRadius: isSelected ? '4px' : 0,
    position: 'relative',
    minHeight: '200px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: textAlign === 'center' ? 'center' : textAlign === 'right' ? 'flex-end' : 'flex-start',
  };

  const overlayStyles = backgroundImage ? {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    borderRadius: 'inherit',
  } : {};

  const contentStyles = {
    position: 'relative',
    zIndex: 1,
    maxWidth: '600px',
    width: '100%',
  };

  const titleStyles = {
    fontSize: previewMode === 'mobile' ? `${titleFontSize * 0.75}px` : `${titleFontSize}px`,
    fontWeight: 'bold',
    marginBottom: '15px',
    lineHeight: 1.2,
    color: titleColor || textColor,
    fontFamily,
  };

  const subtitleStyles = {
    fontSize: previewMode === 'mobile' ? `${descriptionFontSize * 0.9}px` : `${descriptionFontSize}px`,
    marginBottom: showButton ? '25px' : 0,
    lineHeight: 1.4,
    color: subtitleColor || descriptionColor || textColor,
    opacity: 0.9,
    fontFamily,
  };

  const buttonStyles = {
    backgroundColor: buttonBackgroundColor || '#007bff',
    color: buttonTextColor || '#ffffff',
    padding: '12px 30px',
    fontSize: '16px',
    fontWeight: 'bold',
    textTransform: 'none',
    borderRadius: '5px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    '&:hover': {
      backgroundColor: adjustColor(buttonBackgroundColor || '#007bff', -20),
      boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
    },
  };

  function adjustColor(color, amount) {
    if (color.startsWith('#')) {
      const num = parseInt(color.slice(1), 16);
      const r = Math.max(0, Math.min(255, (num >> 16) + amount));
      const g = Math.max(0, Math.min(255, ((num >> 8) & 0x00FF) + amount));
      const b = Math.max(0, Math.min(255, (num & 0x0000FF) + amount));
      return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, '0')}`;
    }
    return color;
  }

  const handleButtonClick = (e) => {
    e.preventDefault();
    if (buttonLink && buttonLink !== '#') {
      window.open(buttonLink, '_blank');
    }
  };

  return (
    <Box
      sx={containerStyles}
    >
      {backgroundImage && <Box sx={overlayStyles} />}
      
      <Box sx={contentStyles}>
        {title && (
          <Typography sx={titleStyles}>
            {title}
          </Typography>
        )}
        
        {(subtitle || description) && (
          <Typography sx={subtitleStyles}>
            {subtitle || description}
          </Typography>
        )}
        
        {showButton && buttonText && (
          <Button
            sx={buttonStyles}
            onClick={handleButtonClick}
          >
            {buttonText}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default HeroBlock; 